import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { AntimalwareAntiExploitUiApplication } from '../../../../../../utils/uiSettings/antimalware/antimalware.types';

// validate duplicates
export function validateDuplicates(
  ruleItem: AntimalwareAntiExploitUiApplication,
  rulesInGrid: AntimalwareAntiExploitUiApplication[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some(
    (ruleInGrid: AntimalwareAntiExploitUiApplication) => ruleInGrid.applicationName === ruleItem.applicationName
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
